const App = {};
window.App = App;

App.order = {
  no_items: 0,
  cost: '',
  storage_provider_present: false,

  logged_in() {
    return !!this.logged_in_user_name;
  },

  empty() {
    return this.no_items === 0;
  },

  items_text() {
    if (this.no_items === 1) {
      return '1 item';
    }
    return `${this.no_items} items`;
  },

  storage_provider_activated() {
    return !!this.storage_provider_present;
  },

  // usage
  // App.order.set('cost', data.totals.items_total);
  // App.order.set('cost': 234)
  set(key, value) {
    this[key] = value;
    return update_template();
  },

  // usage
  // App.order.setProperties(<%={ 'order_id' => @order.order_id, 'no_items' => @order.no_items, 'cost' => @order.basic_total.pence_to_price }.to_safe_json %>);
  // App.order.setProperties({'order_id': '12345', 'no_items': 3, 'cost': 234})
  setProperties(properties) {
    for (const key in properties) {
      const value = properties[key];
      this[key] = value;
    }
    update_template();
    if (this.logged_in()) {
      $('body').addClass('logged-in');
    } else {
      $('body').removeClass('logged-in');
    }
    if (this.storage_provider_present) {
      $('body').addClass('storage-provider-present');
    } else {
      $('body').removeClass('storage-provider-present');
    }
    return null;
  },
};

var update_template = function () {
  const count = App.order.empty() ? '0' : String(App.order.no_items);
  document
    .querySelectorAll('#basket-status, #basket-status-mobile')
    .forEach((el) => {
      el.textContent = count;
    });

  document.querySelectorAll('.js-user-name').forEach((el) => {
    el.textContent = App.order.logged_in_user_name || '';
  });

  return undefined;
};

window.notEmpty = function () {};
window.warnEmpty = function () {};

document.addEventListener('DOMContentLoaded', () => {
  if (window.App?.order && window.initialOrderProps) {
    window.App.order.setProperties(window.initialOrderProps);
  }
});
